var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"icon-gold-circle rounded-full"})
}
var staticRenderFns = []

export { render, staticRenderFns }